<template>
    <div>
        <!-- Main Layout -->
        <CRow class="d-flex align-items-stretch flex-wrap" style="min-height: 500px;">
            <!-- Column 1: Browse Image -->
            <CCol xs="12" sm="8" class="d-flex flex-column p-0" style="min-height: 100%;">
                <CCard class="p-4 border-19px d-flex flex-column" style="border:none; min-height: 100%;">
                    <CRow>
                <CCol xs="12" sm="9">
                            <h3 class="custom-14px-500 font-inter">Browse Image</h3>
                            <input type="file" id="thumbnail" ref="mythumbnail" @change="onFileChange" />
    
                          
    
    
                        </CCol>
                        <CCol xs="12" sm="3">
                            <CButton type="button" class="bg-3A70EA text-white mt-3 border-9px" @click="handleFileUpload">
                                Analysis Object
                            </CButton>
                        </CCol>
                    </CRow>
                    <!-- Backdrop/Overlay when loading -->
                    <div v-if="isLoading" class="loading-backdrop">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="custom-20px-500 text-center text-white">Currently Analysis Images</p>
                            <p class="custom-14px-400 text-center text-white">
                                The system is processing images to improve model accuracy and performance.
                            </p>
                        </div>
                    </div>
                    <CCard class="bg-F9FAFB mt-3 flex-grow-1 d-flex align-items-center justify-content-center" style="overflow: hidden;">
                        <div class="text-center w-100">
                            <div v-if="!processedFrameSrc && videoLinkYoutube" id="preview">
    <iframe :src="embedYouTubeLink" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 100%; width: 100%; height: 315px;"></iframe>
</div>
                            <div v-if="!processedFrameSrc && isVideo && urlThumbnail" id="preview">
                                <video controls :src="urlThumbnail" class="border-16px" style="max-width: 100%;"></video>
                            </div>
                            <div v-if="!processedFrameSrc && isImage && urlThumbnail" id="preview">
                                <img :src="urlThumbnail" alt="Image Preview" class="image-preview border-16px" style="max-width: 100%;" />
                            </div>
    
                            <div v-if="processedFrameSrc && isVideo">
                                <video controls autoplay muted :src="processedFrameSrc" class="border-16px" style="max-width: 100%;" type="video/mp4"></video>
                            </div>
                          
                            <div v-if="processedFrameSrc && videoLinkYoutube">
                                <iframe :src="processedFrameSrc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 100%; width: 100%; height: 315px;"></iframe>
                            </div>
                            <div v-if="processedFrameSrc && isImage">
    
    
                                <img :src="processedFrameSrc" alt="Processed Image" class="image-preview border-16px" style="max-width: 100%;" />
                            </div>
                            <span class="font-color-696969">SVG, PNG, JPG, GIF, or MP4 (max. 800x400px)</span>
                        </div>
                    </CCard>
                </CCard>
            </CCol>
    
            <!-- Column 2: History Training -->
            <CCol xs="12" sm="4" class="d-flex flex-column p-1" style="min-height: 100%;">
                <br class="d-md-none d-lg-none" />
                <CCard class="p-4 border-19px custom-scroll-hide" style="border:none; min-height: 100%;">
                    <h3 class="custom-18px-500 font-color-101828 text-left">Analysis</h3>
                    <!-- <div v-for="(item, index) in predict" :key="index">
                        <CRow class="mt-1">
                            <CCol md="2">
                                <img src="../assets/img/random/circlesmallblue.png" width="10px" />
                            </CCol>
                            <CCol md="10">
                                <p class="font-inter font-color-101828">
                                    Training the model for Image Detection was completed on {{ item.time }}.
                                    <br> Final Accuracy: {{ item.final_accuracy }}%
                                    <br> Final Loss: {{ item.final_loss }}
                                    <br> Detected Objects: {{ item.count }}
                                </p>
                                <label class="custom-14px-400 font-color-98A2B3">{{ item.relativeTime }}</label>
                            </CCol>
                            <CCol xs="12">
                                <hr class="custom-hr" />
                            </CCol>
                        </CRow>
                    </div> -->

                    <div v-if="predict && predict.length">
                        <div v-for="(item, index) in predict" v-bind:key="index">
                            <p class="font-inter font-color-101828">
                                    Analysis the model for Image Detection was completed with {{ item.class }} - confidence level {{ (item.confidence * 100).toFixed(2) }}%
                            </p>
                                </div>
                        </div>
                        <div v-else>
                        No predictions available.
                        </div>
                </CCard>
            </CCol>
        </CRow>
    
        <br class="d-md-none d-lg-none" /><br class="d-md-none d-lg-none" />
        <!-- Training Result Test Section -->
        <CRow class="d-flex align-items-stretch flex-wrap mt-2">
            <CCol md="12" class="p-1">
                <CCard class="p-4 border-19px" style="border:none;">
                    <h3 class="custom-18px-500 mb-3">Analysis Result Test</h3>
                    <CRow>
                        <!-- <CCol xs="12" sm="6" lg="3">
                            <CChartLine :datasets="lineChartDatasetsAccuracy" :labels="timeLabels" :options="chartOptions" />
                        </CCol>
                        <CCol xs="12" sm="6" lg="3">
                            <CChartLine :datasets="lineChartDatasets" :labels="timeLabels" :options="chartOptions" />
                        </CCol>
                        <CCol xs="12" sm="6" lg="3">
                            <CChartLine :datasets="lineChartDatasetsCount" :labels="timeLabels" :options="chartOptions" />
                        </CCol> -->
                        <CCol xs="12" sm="6" lg="12">
                            <CChartBar :datasets="computedDatasets" :options="computedOptions" :labels="labels" />
                        </CCol>
                    </CRow>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs';
export default {
    components: {
        CChartLine,
        CChartBar,
    },
    data() {
        return {
            urlThumbnail: null, // URL for the preview image
            selectedImage: null, // Store the uploaded image file
            processedFrameSrc: null, // Placeholder for processed image
            isLoading: false, // Loading state to show spinner
            count: 0, // Current detected object count
            history: [], // Array to store detection history
            final_accuracy: "",
            final_loss: "",

            timeLabels: [],

            groupedObjects: [], // Initialize as an empty array
        

            isImage: false,
            isVideo: false,
            processedFileSrc: null,
            selectedFile: null,
            videoSrc: "",
            videoLinkYoutube: "",
            embedYouTubeLink: "", 
            predict:[],
            labels: [], // Labels for the bar chart
        datasets: [], // Data for the bar chart








        };
    },
    mounted: function() {
        this.videoSrc = "https://192.168.0.2:5040/processed_images/processed_79082469294649a7b80305751b209bfb.mp4";
    },
    computed: {
    computedDatasets() {
        return [
            {
                label: 'Confidence Levels',
                data: this.datasets,
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderWidth: 1,
            },
        ];
    },
    computedOptions() {
        return {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: 'Confidence',
                    },
                },
                x: {
                    title: {
                        display: true,
                        text: 'Predictions',
                    },
                },
            },
        };
    },
},
   
    methods: {
        onFileChangeThumbnail(event) {
            this.processedFrameSrc = null;

            const file = event.target.files[0]; // Get the selected file from the event
            if (file) {
                this.urlThumbnail = URL.createObjectURL(file); // Set the image URL for preview
                this.selectedImage = file; // Store the selected image
                console.log("File selected:", file); // Check if file selection works
            } else {
                console.log("No file selected");
            }
        },
        updatePreview() {
        if (this.isYouTubeUrl(this.videoLinkYoutube)) {
            this.isImage = false;
            this.isVideo = false;
            this.selectedFile = null;
            this.urlThumbnail = '';
            this.processedFrameSrc = null; // Clear the processed frame source
            if (this.$refs.mythumbnail) {
                this.$refs.mythumbnail.value = ""; // Reset file input
            }
            console.log("test"+ this.convertToEmbedUrl(this.videoLinkYoutube));
                    this.embedYouTubeLink = this.convertToEmbedUrl(this.videoLinkYoutube);
                } else {
                    this.embedYouTubeLink = "";
                }
            },
    isYouTubeUrl(url) {
        const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/|embed\/)|youtu\.be\/)[\w\-\?&=#]+$/;
        return youtubeRegex.test(url);
    },

    convertToEmbedUrl(url) {
        const videoId = this.extractVideoId(url);
        return `https://www.youtube.com/embed/${videoId}`;
    },

    extractVideoId(url) {
        const regExp = /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w\-]+)/;
        const match = url.match(regExp);
        return match ? match[1] : "";
    },


        onFileChange(event) {
            this.processedFrameSrc = null;
            const file = event.target.files[0];
            if (file) {
                this.urlThumbnail = URL.createObjectURL(file);
                this.selectedFile = file;
                this.isImage = file.type.startsWith("image/");
                this.isVideo = file.type.startsWith("video/");
                this.videoLinkYoutube = "";
                console.log(`File type: ${file.type}`);
                console.log(`Is Image: ${this.isImage}, Is Video: ${this.isVideo}`);
            } else {
                console.log("No file selected");
            }
        },
        handleFileUpload() {
            // First, check if a valid YouTube URL has been entered

            // If no valid YouTube link, check for selected file
            if (!this.selectedFile && !this.videoLinkYoutube) {
                alert('Please select an image, video, or enter a valid YouTube URL.');
                return; // Exit if no file is selected or URL is entered
            }

            // Handle image upload
            if (this.isImage) {
                console.log("Uploading Image:", this.selectedFile);
                this.sendFrame(); // Call the function for image upload
            }
            // Handle video file upload
            else if (this.isVideo) {
                console.log("Uploading Video:", this.selectedFile);
                this.sendFrameVideo(); // Call the function for video file upload
            } else if (this.videoLinkYoutube) {
                console.log("Uploading Video:", this.videoLinkYoutube);
                this.sendFrameVideoYoutube(); // Call the function for video file upload
            } else {
                // Fallback if no valid image or video file selected
                alert('Invalid file type. Please select an image or video file.');
            }
        },
        sendLink() {
            this.sendFrameVideoYoutube();

        },

        sendFrame() {
    // Ensure the user has uploaded an image
    if (!this.selectedFile || !this.isImage) {
        console.log("No image selected");
        return; // Do nothing if no image is selected
    }

    // Set loading state to true to show the backdrop and spinner
    this.isLoading = true;

    // Create the FormData object
    const formData = new FormData();
    formData.append('video_path', this.selectedFile); // Append the selected image

    // Send the image to the server
    fetch('https://devai.mywire.org/process-weapon-model', { // Update with your Flask server URL
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json()) // Expecting a JSON response
        .then((data) => {
            console.log("Server response:", data);

            // Ensure data.predictions is valid
            this.predict = data.predictions || [];
            this.processedFrameSrc = data.labeled_image_url 
                ? `https://devai.mywire.org${data.labeled_image_url}`
                : '';

            // Update the chart with the predictions
            this.updateChart(this.predict);

            // Reset the loading state
            this.isLoading = false;
        })
        .catch((error) => {
            console.error("Error sending image:", error);

            // Ensure loading state is reset in case of error
            this.isLoading = false;
        });
},
        // Function to display results in the UI

        beforeDestroy() {
            // Revoke the object URL if it exists to avoid memory leaks
            if (this.urlThumbnail) {
                URL.revokeObjectURL(this.urlThumbnail);
            }
        },
        sendFrameVideo() {
            if (!this.selectedFile || !this.isVideo) {
                console.log("No video selected");
                return;
            }

            this.isLoading = true;
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            fetch('https://devai.mywire.org/process_video', {
                    method: 'POST',
                    body: formData,
                })
                .then((response) => response.json())
                .then((data) => {
                    console.log("Server response received:", data);

                    // Extract server response
                    const { file_url, count, final_accuracy, final_loss, grouped_objects } = data;

                    // Update processed video URL
                    this.processedFrameSrc = file_url;

                    // Update history
                    const currentTime = new Date();
                    this.history.unshift({
                        count,
                        time: currentTime.toLocaleTimeString(),
                        final_accuracy,
                        final_loss,
                        relativeTime: "just now",
                    });
                    this.history = [...this.history]; // Ensures Vue reactivity

                    // Update grouped objects and chart data
                    this.groupedObjects = grouped_objects;
                    this.labels = grouped_objects.map((obj) => obj.type);

                    // Force chart update if needed
                    if (this.$refs.myChart) {
                        this.$refs.myChart.update();
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Error sending video:", error);
                    alert("Failed to process video. Please try again.");
                    this.isLoading = false;
                });
        },
        sendFrameVideoYoutube() {
            this.isLoading = true;

            fetch('https://devai.mywire.org/process_youtube_link', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        url: this.convertToEmbedUrl(this.videoLinkYoutube),
                    })
                })


                .then((response) => response.json())
                .then((data) => {
                    console.log("Server response received:", data);

                    // Extract server response
                    const { file_url, count, final_accuracy, final_loss, grouped_objects } = data;
                    this.processedFrameSrc = file_url;

                    // Update processed video URL
                    const currentTime = new Date();
                    const timeString = currentTime.toLocaleTimeString();

                    // Calculate relative time
                    let relativeTime = 'just now';
                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time; // The time of the last upload
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000); // Difference in minutes

                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }


                    this.groupedObjects = grouped_objects;

                    // Update labels for the bar chart
                    this.labels = grouped_objects.map((obj) => obj.type);

                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time;
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000);
                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }

                    // Update the history array with the new data
                    this.history.unshift({
                        count: count,
                        time: timeString,
                        final_accuracy: final_accuracy,
                        final_loss: final_loss,
                        relativeTime: relativeTime, // Set relative time based on the difference
                        grouped_objects: grouped_objects
                    });

                    // Update time labels for the chart
                    this.timeLabels.unshift(timeString);

                    // Set loading state to false after the image is processed
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Error sending video:", error);
                    alert("Failed to process video. Please try again.");
                    this.isLoading = false;
                });
        },
        onVideoCanPlay() {
            const videoElement = this.$refs.videoRef;

            // Check if the video is ready to play (it has enough data)
            if (videoElement.readyState >= 3) {
                // Video has enough data to play
                videoElement.play().catch(err => {
                    console.error("Error playing the video:", err);
                });
            } else {
                // Listen for the "canplay" event to ensure it's ready
                videoElement.addEventListener('canplay', () => {
                    videoElement.play().catch(err => {
                        console.error("Error playing the video:", err);
                    });
                });
            }
        },
        updateChart: function updateChart(predictions) {
    if (!predictions || !Array.isArray(predictions)) {
        console.error("Invalid predictions data:", predictions);
        return;
    }

    // Update chart labels and data
    this.labels = predictions.map((prediction, index) => `Prediction ${index + 1} (${prediction.class})`);
    this.datasets = predictions.map((prediction) => prediction.confidence.toFixed(2)); // Use confidence directly
},

    }

};
</script>

<style scoped>
/* Styling for the loading backdrop */

.loading-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Grey backdrop */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    /* Ensure it sits on top of content */
    color: #fff;
    text-align: center;
}

/* Style for the spinner */

.spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.25em;
}

.spinner-border text-primary {
    color: #3A70EA;
    /* Adjust the spinner color */
}

.d-flex.align-items-stretch .CCol {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* Ensure CCard within columns stretches */

.CCol .CCard {
    flex: 1;
    /* Make CCard take up all available space */
}

.c-main {
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    padding-top: 0rem;
}
</style>